// extracted by mini-css-extract-plugin
export default {"addEventsBox":"addEvents_addEventsBox__t68ym","imgBox":"addEvents_imgBox__zyRZn","langTitle":"addEvents_langTitle__jeZEk"};